import React from "react";

const PDFViewer = () => {
 return (
 <div>
 <iframe src="../public/ShinjinSantakumarResume.pdf" height="500px" width="100%"></iframe>
 </div>
 );
};
export default PDFViewer;


// WEBPACK FOOTER //
// ./src/components/Resume.js